export const MAX_APPEARANCE_FONT_SIZE_BYTES = 10 * 1024 * 1024;
export const APPEARANCE_FONT_PREVIEW_FAMILY = 'appearance-font-preview';
export const MIN_ELEMENT_BORDER_ROUNDING = 0;
export const MAX_ELEMENT_BORDER_ROUNDING = 100;

export const AMCON_COLOR_PALETTE = {
  blue: '2D6BA9',
  gray: '4E5256',
  black: '000000',
  white: 'FFFFFF',
} as const;
